import { MiddlewareCreatorType, MiddlewareType } from '../relay-types';

export const authMiddleware: MiddlewareCreatorType =
    (_, tokenRefresher, devToken): MiddlewareType =>
    async (args, next) => {
        const { context } = args;
        if (!context.request) {
            return next(args);
        }

        const freshToken = devToken ?? (await tokenRefresher());

        context.request.headers = {
            ...context.request.headers,
            Authorization: `Bearer ${freshToken}`,
        };

        return next(args);
    };
